"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEV_TELEPHONE_AUDIT_EVENT_TYPES = void 0;
const enums_1 = require("../enums");
exports.DEV_TELEPHONE_AUDIT_EVENT_TYPES = [enums_1.AuditLogEventType.CreateDevTelephoneNumber, enums_1.AuditLogEventType.UpdateDevTelephoneNumber, enums_1.AuditLogEventType.DeleteDevTelephoneNumber];
//# sourceMappingURL=dev-telephone-audit.js.map